import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import api from '../../api/axios';
import { useAuth } from '../../context/AuthContext';
import { StatusBadge, PriorityBadge } from '../../components/StatusBadge';

const MyTickets = () => {
  const { user } = useAuth();
  const [tickets, setTickets] = useState([]);
  const [filter, setFilter] = useState('ALL');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/api/kam/${user.userId}/tickets`)
      .then(res => setTickets(res.data))
      .finally(() => setLoading(false));
  }, [user.userId]);

  const filtered = filter === 'ALL' ? tickets : tickets.filter(t => t.status === filter);

  return (
    <div className="min-h-screen bg-gray-50">
      
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-800">My Tickets</h1>
            <p className="text-gray-500 text-sm">{tickets.length} total tickets</p>
          </div>
          <Link to="/kam/raise"
            className="bg-primary text-white px-5 py-2.5 rounded-lg hover:bg-primary-light transition-colors font-medium text-sm">
            + Raise Ticket
          </Link>
        </div>

        <div className="flex gap-2 mb-6">
          {['ALL', 'OPEN', 'IN_PROGRESS', 'RESOLVED'].map(s => (
            <button key={s} onClick={() => setFilter(s)}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                filter === s ? 'bg-primary text-white' : 'bg-white text-gray-600 border border-gray-200 hover:bg-gray-50'
              }`}>
              {s.replace('_', ' ')}
              <span className="ml-1.5 text-xs opacity-70">
                ({s === 'ALL' ? tickets.length : tickets.filter(t => t.status === s).length})
              </span>
            </button>
          ))}
        </div>

        {loading ? (
          <div className="text-center py-12 text-gray-400">Loading tickets...</div>
        ) : filtered.length === 0 ? (
          <div className="bg-white rounded-xl border border-gray-100 p-12 text-center text-gray-400">
            No tickets found
          </div>
        ) : (
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-100">
                <tr>
                  {['Ticket ID', 'Enterprise', 'Type', 'Priority', 'Status', 'Agent', 'Created', ''].map(h => (
                    <th key={h} className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {filtered.map(t => (
                  <tr key={t.ticketId} className="hover:bg-gray-50 transition-colors">
                    <td className="px-4 py-3 text-sm font-medium text-primary">{t.ticketId}</td>
                    <td className="px-4 py-3 text-sm text-gray-700">{t.enterpriseName}</td>
                    <td className="px-4 py-3 text-sm text-gray-500">{t.ticketType || '-'}</td>
                    <td className="px-4 py-3"><PriorityBadge priority={t.priority} /></td>
                    <td className="px-4 py-3"><StatusBadge status={t.status} /></td>
                    <td className="px-4 py-3 text-sm text-gray-500">{t.assignedAgentName || '-'}</td>
                    <td className="px-4 py-3 text-xs text-gray-400">
                      {t.createdAt ? new Date(t.createdAt).toLocaleDateString() : '-'}
                    </td>
                    <td className="px-4 py-3">
                      <Link to={`/kam/tickets/${t.ticketId}`}
                        className="text-xs text-primary hover:text-primary-dark font-medium">View</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyTickets;
